module.exports = __webpack_public_path__ + "static/media/claim-settings-icon.203d7bc1.svg";